import { model, Model, view } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { GenericCourseListModel } from './GenericCourseListModel';

export class CourseListMap extends Model({
  map: types.map(GenericCourseListModel),
}) {
  private _set(type: string) {
    this.map.set(type, { type });
  }

  @view
  get(type: string) {
    if (this.map.has(type)) {
      return this.map.get(type)!;
    } else {
      this._set(type);
      return this.map.get(type)!;
    }
  }
}

export const CourseListMapModel = model(CourseListMap);
